import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginAPI } from '../ultilies/API';

function Login() {
    const [credentials, setCredentials] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        // localStorage.setItem("token", "tokennnnn");
        // localStorage.setItem("loginTime", Date.now());
        // navigate('/dashboard');
        // window.location.reload();
        LoginAPI(credentials, (res) => {
            if (res.success) {
                localStorage.setItem("token", res.accessToken);
                localStorage.setItem("loginTime", Date.now());
                navigate('/staticplayabledashboard');
                window.location.reload();
            } else {
                setError("Invalid Username or Password");
            }
        });
    };

    return (
        <div className="login-container">
            <img src='/assets/image.png' alt='iopex-logo' className='logo'/>

            <form className="login-form" onSubmit={handleLogin}>
                <h2>Login</h2>
                {error && <p className="error-text">{error}</p>}
                <input
                    type="text" placeholder="Username" required
                    onChange={e => setCredentials({ ...credentials, username: e.target.value })}
                />
                <input
                    type="password" placeholder="Password" required
                    onChange={e => setCredentials({ ...credentials, password: e.target.value })}
                />
                <button type="submit" className="btn-export app-btn-primary">Login</button>
            </form>

        </div>
    );
}

export default Login;